// 📁 frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { CartProvider } from './context/CartContext';

import CartPage from './pages/CartPage';
import ProductDetails from './pages/ProductDetails';
import CategoriesPage from './pages/CategoriesPage';
import Test from './pages/test';

// ✅ صفحات المشرف
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminLayout from './pages/AdminLayout';
import AdminOrdersPage from './pages/AdminOrdersPage';
import AddProductPage from './pages/AddProductPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';
import AdminDeliveryZonesPage from './pages/AdminDeliveryZonesPage';
import PrintOrderPage from './pages/PrintOrderPage';
import AdminCostsPage from "./pages/AdminCostsPage";

import HomeLandingPage from './pages/HomeLandingPage'; // ✅ الصفحة الرئيسية
import WhatsAppButton from './components/WhatsAppButton'; // ✅ زر واتساب قابل للتحريك

// ✅ التحقق من تسجيل دخول المشرف
const isAdminLoggedIn = () => {
  return localStorage.getItem('admin') !== null;
};

// ✅ راوت محمي
const ProtectedRoute = ({ children }) => {
  return isAdminLoggedIn() ? children : <Navigate to="/admin/login" />;
};

function App() {
  return (
    <CartProvider>
      <Router>
        {/* ✅ زر واتساب يظهر في كل الصفحات */}
        <WhatsAppButton />

        <Routes>
          {/* 📦 صفحات المستخدم */}
          <Route path="/" element={<HomeLandingPage />} />
          <Route path="/test" element={<Test />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* 🛠️ صفحات المشرف */}
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<AdminDashboardPage />} />
            <Route path="orders" element={<AdminOrdersPage />} />
            <Route path="products/create" element={<AddProductPage />} />
            <Route path="categories" element={<AdminCategoriesPage />} />
            <Route path="zones" element={<AdminDeliveryZonesPage />} />
            <Route path="costs" element={<AdminCostsPage />} />
            <Route path="orders/print/:orderId" element={<PrintOrderPage />} />
          </Route>
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
